<template>
  <AdminAppLayout title="HRDOS | Employees List"> 

    <div class="row">
        <div 
          @click="toggleStatus(1, 'PERMANENT')" 
          class="col s12 m3" 
          style="min-width: 200px !important; cursor: pointer;"
        >
          <div 
            class="card blue darken-1 hoverable"
            :style="status !== '' && status !== 1 ? 'opacity: 0.5; transition: 0.3s;' : 'opacity: 1; transition: 0.3s;'"
          >
            <div class="card-content white-text left-align filter-card">
              <h3 style="margin-top: 0;"><b>{{ statusCounts['PERMANENT'] ?? 0 }}</b></h3>
              <p style="font-size: 1.1rem;font-weight: bold;">PERMANENT</p>
            </div>
          </div>
        </div>

        <div 
          @click="toggleStatus(2, 'CASUAL')" 
          class="col s12 m3" 
          style="min-width: 200px !important; cursor: pointer;"
        >
          <div 
            class="card orange darken-1 hoverable"
            :style="status !== '' && status !== 2 ? 'opacity: 0.5; transition: 0.3s;' : 'opacity: 1; transition: 0.3s;'"
          >
            <div class="card-content white-text left-align filter-card">
              <h3 style="margin-top: 0;"><b>{{ statusCounts['CASUAL'] ?? 0 }}</b></h3>
              <p style="font-size: 1.1rem;font-weight: bold;">CASUAL</p>
            </div>
          </div>
        </div>

      <div 
        @click="toggleStatus(3, 'CONTRACT OF SERVICE (JOB ORDER)')" 
        class="col s12 m3" 
        style="min-width: 200px !important; cursor: pointer;"
      >
        <div 
          class="card green darken-1 hoverable"
          :style="status !== '' && status !== 3 ? 'opacity: 0.5; transition: 0.3s;' : 'opacity: 1; transition: 0.3s;'"
        >
          <div class="card-content white-text left-align filter-card">
            <h3 style="margin-top: 0;"><b>{{ statusCounts['CONTRACT OF SERVICE (JOB ORDER)'] ?? 0 }}</b></h3>
            <p style="font-size: 1.1rem;font-weight: bold;">JOB ORDER (JO)</p>
          </div>
        </div>
      </div>
    </div>
    
    <div class="row" style="margin-bottom: 10px;">

      <div class="search-wrapper valign-wrapper col s12 m5">
        <i class="material-icons indigo-text text-lighten-4" style="margin-right: 10px;">search</i>
        <div class="input-field search" style="width: 100%; margin: 0;">
          <input 
          id="search" 
          type="text"
          v-model="search"
          class="custom-search-input" 
          @input="handleSearchInputDelay()"
          placeholder="Search employees (name or ID...)">
        </div>
      </div>

      <!-- OFFICE FILTER -->
      <div class="col s12 m2" style="margin-top: 10px;">
        <select 
          class="browser-default" 
          v-model="selectedOffice" 
          @change="filterLists(1)" 
          style="border: 1px solid #ccc; border-radius: 6px; padding: 0 10px; height: 40px; width: 100%;"
        >
          <option value="" selected>All Assigned Offices</option>
          <option v-for="office in dropdowns.offices" :key="office.id" :value="office.id">{{ office.name }}</option>
        </select>
      </div>

      <div class="col s12 m2" style="margin-top: 10px;">
        <select 
          class="browser-default" 
          v-model="selectedPlantilla" 
          @change="filterLists(1)" 
          style="border: 1px solid #ccc; border-radius: 6px; padding: 0 10px; height: 40px; width: 100%;"
        >
          <option value="" selected>All Plantillas</option>
          <option v-for="plantilla in dropdowns.plantillas" :key="plantilla.id" :value="plantilla.id">{{ plantilla.name }}</option>
        </select>
      </div>

      <div class="col s12 m3 right-align hide-on-med-and-down" style="margin-top: 10px;">
        <button
          class="btn green darken-1"
          style="border-radius: 6px;"
          @click="goToAddEmployee()"
        >
          <b>+ Add New</b>
        </button>
      </div>

      <div class="fixed-action-btn hide-on-large-only">
      <a
        class="btn-floating btn-large green darken-1"
        @click="goToAddEmployee()"
      >
        <i class="large material-icons">add</i>
      </a>
    </div>
    </div>

    <!-- filters display -->
    <div class="row" v-if="filtered" style="margin-top: -10px; margin-bottom: 20px; padding-left: 10px;">
      <div class="col s12 valign-wrapper" style="flex-wrap: wrap; gap: 8px;">
        <span class="grey-text text-darken-2" style="font-size: 0.95rem; margin-right: 5px;"><b>Filters:</b></span>
        
        <div class="chip indigo lighten-1 white-text" style="margin: 0; display: inline-flex; align-items: center;" v-if="statusName">
          <p><b>Status:</b> {{ statusName }}</p>
          <i class="material-icons" style="cursor: pointer; font-size: 16px; margin-left: 8px;" @click="removeSpecificFilter('status')">close</i>
        </div>
        
        <div class="chip indigo lighten-1 white-text" style="margin: 0; display: inline-flex; align-items: center;" v-if="search">
          <p><b>Search:</b> "{{ search }}"</p>
          <i class="material-icons" style="cursor: pointer; font-size: 16px; margin-left: 8px;" @click="removeSpecificFilter('search')">close</i>
        </div>
        
        <div class="chip indigo lighten-1 white-text" style="margin: 0; display: inline-flex; align-items: center;" v-if="selectedOffice">
          <p><b>Office:</b> {{ getOfficeName(selectedOffice) }}</p>
          <i class="material-icons" style="cursor: pointer; font-size: 16px; margin-left: 8px;" @click="removeSpecificFilter('office')">close</i>
        </div>
        
        <div class="chip indigo lighten-1 white-text" style="margin: 0; display: inline-flex; align-items: center;" v-if="selectedPlantilla">
          <p><b>Plantilla:</b> {{ getPlantillaName(selectedPlantilla) }}</p>
          <i class="material-icons" style="cursor: pointer; font-size: 16px; margin-left: 8px;" @click="removeSpecificFilter('plantilla')">close</i>
        </div>
        
        <button class="btn-flat red-text" @click="resetFilters" style="padding: 0 10px; text-transform: none; font-weight: 600;">
          Clear Filter <i class="material-icons right" style="font-size: 1.1rem; margin-left: 2px;">clear</i>
        </button>
      </div>
    </div>
    
    <div class="divider" style="margin-bottom: 25px;border-bottom: 2px dashed #283593;"></div>
          <div class="table-responsive-wrapper hide-on-med-and-down" v-show="listLoader">
            <table class="highlight">
              <thead>
                <tr>
                  <th>No.</th>
                  <th>Profile</th>
                  <th class="nowrap">LTO ID</th>
                  <th>Name</th>
                  <th>Plantilla</th>
                  <th class="nowrap">Salary</th>
                  <th>Email</th>
                  <th class="nowrap">Item</th>
                  <th class="nowrap" colspan="2">Action</th> 
                </tr>
              </thead>
              <tbody>
                <tr v-for="n in 3" :key="'skeleton-row-' + n">
                  <td><div class="skeleton skeleton-text" style="width: 20px;"></div></td>
                  
                  <td style="width: 60px;">
                    <div class="skeleton skeleton-circle" style="width: 60px; height: 60px;"></div>
                  </td>
                  
                  <td><div class="skeleton skeleton-text" style="width: 70px;"></div></td>
                  
                  <td><div class="skeleton skeleton-text" style="width: 130px;"></div></td>
                  
                  <td><div class="skeleton skeleton-text" style="width: 160px;"></div></td>
                  
                  <td><div class="skeleton skeleton-text" style="width: 80px;"></div></td>
                  
                  <td><div class="skeleton skeleton-text" style="width: 170px;"></div></td>
                  
                  <td><div class="skeleton skeleton-text" style="width: 50px;"></div></td>
                  
                  <td class="nowrap"><div class="skeleton skeleton-button"></div></td>
                  
                  <td class="nowrap"><div class="skeleton skeleton-button"></div></td>
                </tr>
              </tbody>
            </table>
          </div>

    <div class="table-responsive-wrapper hide-on-med-and-down" v-show="!listLoader">
      <table class="highlight">
        <thead>
          <tr>
            <th>No.</th>
            <th>Profile</th>
            <th class="nowrap">LTO ID</th>
            <th>Name</th>
            <th>Plantilla</th>
            <th class="nowrap">Salary</th>
            <th>Email</th>
            <th class="nowrap">Item</th>
            <th class="nowrap">Action</th>
          </tr>
        </thead>
        <tbody>
          <tr v-if="!employees.length">
            <td v-if="status" class="center-align" colspan="10">No records found under {{ statusName }}</td>
            <td v-else class="center-align" colspan="10">No records found...</td>
          </tr>

          <tr v-else v-for="(employee, i) in employees" :key="employee.id">
            <td>{{ (pagination.current_page - 1) * 10 + i + 1 }}</td>
            <td style="width: 60px;">
              <img class="circle" style="object-fit: cover;width: 60px;height: 60px;" :src="getPhoto(employee.profile_photo)" alt="Profile">
            </td>
            <td><b>{{ employee.employee_id_number }}</b></td>
            <td>{{ employee.full_name }}</td>
            <td>{{ employee.plantilla?.name || 'N/A' }}</td>
            <td class="nowrap">₱{{ formatCurrency(employee.salary_grade ? employee.salary_grade.salary_amount : employee.base_salary) }}</td>
            <td>{{ employee.user.email }}</td>
            <td class="nowrap">{{ employee.item_number ?? 'N/A'}}</td>
            <td class="nowrap">
              <button @click="getEmployeeDetails(employee.id)" class="btn-small yellow darken-4 modal-trigger" data-target="viewDiv" style="border-radius: 4px;"><b>View</b></button>
            </td>
            <td class="nowrap">
              <button @click="openEditModal(employee)" class="btn-small blue darken-1" style="border-radius: 4px;"><b>Edit</b></button>
            </td>

          </tr>
        </tbody>
      </table>
    </div>

          <div class="row hide-on-large-only left-align" v-show="listLoader">
        
            <div v-for="n in 4" :key="'skeleton-mobile-' + n" class="col s12 m6">
              <div style="height: 180px; box-shadow: none; border: 1px solid #f5f5f5;" class="card horizontal">
                
                <div style="max-width: 35%; min-width: 35%; height: 100%;" class="skeleton"></div>
                
                <div class="card-stacked">
                  <div class="card-content">
                    <div class="skeleton skeleton-text" style="width: 85%; height: 16px; margin-bottom: 20px;"></div>
                    <div class="skeleton skeleton-text" style="width: 65%; height: 16px;"></div>
                  </div>
                  
                  <div class="card-action" style="display: flex; align-items: center;">
                    <div class="skeleton skeleton-button" style="margin: 2%;"></div>
                    <div class="skeleton skeleton-button" style="margin: 2%;"></div>
                  </div>
                </div>

              </div>
            </div>

          </div>

          <div class="row hide-on-large-only left-align" v-show="!listLoader">
      <div v-for="employee in employees" :key="employee.id" class="col s12 m6">
        <div style="height: 180px;" class="card horizontal">
          <div style="max-width: 35%;min-width: 35%;" class="card-image">
            <img style="width: 100%;height: 100%;object-fit: cover;" :src="getPhoto(employee.profile_photo)">
          </div>
          <div class="card-stacked">
            <div class="card-content">
              <p><b>LTO ID : <span>{{ employee.employee_id_number }}</span></b></p>
              <p><b>Name : <span>{{ employee.full_name }}</span></b></p>
            </div>
            <div class="card-action">
                <button @click="getEmployeeDetails(employee.id)" class="btn-small yellow darken-4 modal-trigger" data-target="viewDiv" style="border-radius: 4px;margin: 2%;"><b>View</b></button>
                <button @click="openEditModal(employee)" class="btn-small blue darken-1" style="border-radius: 4px;margin: 2%;"><b>Edit</b></button>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="center-align" v-if="pagination.last_page > 1" v-show="!listLoader" style="margin-top: 20px; margin-bottom: 30px;">
      <ul class="pagination">
        <li :class="{ disabled: pagination.current_page === 1 }">
          <a href="#!" @click.prevent="changePage(pagination.current_page - 1)">
            <i class="material-icons">chevron_left</i>
          </a>
        </li>
        
        <li v-for="page in visiblePages" :key="page" 
            :class="{ 'active blue darken-1': pagination.current_page === page, 'waves-effect': pagination.current_page !== page }">
           <a href="#!" @click.prevent="changePage(page)">{{ page }}</a>
        </li>

        <li :class="{ disabled: pagination.current_page === pagination.last_page }">
          <a href="#!" @click.prevent="changePage(pagination.current_page + 1)">
            <i class="material-icons">chevron_right</i>
          </a>
        </li>
      </ul>
      <p class="grey-text" style="font-size: 0.9rem; margin-top: 5px;">
        Showing page {{ pagination.current_page }} of {{ pagination.last_page }} (Total: {{ pagination.total }} records)
      </p>
    </div>
    
    <!-- for viewing employee informations modal -->
    <div id="viewDiv" class="modal main-modal">
      
      <div class="modal-content white lighten-4" style="padding: 0;">
        <div class="modal-header blue" style="display: flex; justify-content: space-between; align-items: center; padding: 15px 24px; position: sticky; top: 0; z-index: 10;">
          <h5 class="white-text" style="margin: 0; font-weight: 600;">Employee Information</h5>
          <a href="#!" class="modal-close white-text close-x-btn" style="display: flex; align-items: center; justify-content: center; padding: 4px; border-radius: 50%;">
            <i class="material-icons" style="font-size: 2rem;">close</i>
          </a>
        </div>

        <div style="padding: 24px;">
          <div class="content-skeleton" v-show="detailsLoader">
            <div class="row profile-hero center-align">
              <div class="col s12">
                <div class="skeleton skeleton-circle" style="width: 140px; height: 140px; margin: 0 auto 15px auto; border: 4px solid #ffffff; box-shadow: 0 6px 16px rgba(0, 0, 0, 0.12);"></div>
                <div class="skeleton" style="width: 250px; height: 28px; border-radius: 4px; margin: 0 auto 10px auto;"></div>
                <div class="skeleton" style="width: 160px; height: 32px; border-radius: 20px; margin: 0 auto 10px auto;"></div>
                <div v-if="currentUser['id'] === 1" class="skeleton" style="width: 130px; height: 32px; border-radius: 20px; margin: 0 auto;"></div>
              </div>
            </div>

            <div class="row">
              <div class="col s12 m6">
                <div class="card info-card z-depth-0">
                  <div class="card-content center-align">
                    <div class="skeleton" style="width: 50%; height: 24px; border-radius: 4px; margin: 0 auto 25px auto;"></div>
                    <div class="info-item" style="margin-bottom: 20px;">
                      <div class="skeleton" style="width: 30%; height: 10px; border-radius: 4px; margin: 0 auto 8px auto;"></div>
                      <div class="skeleton" style="width: 40%; height: 18px; border-radius: 4px; margin: 0 auto;"></div>
                    </div>
                    <div class="info-item" style="margin-bottom: 20px;">
                      <div class="skeleton" style="width: 30%; height: 10px; border-radius: 4px; margin: 0 auto 8px auto;"></div>
                      <div class="skeleton" style="width: 50%; height: 18px; border-radius: 4px; margin: 0 auto;"></div>
                    </div>
                    <div class="info-item" style="margin-bottom: 20px;">
                      <div class="skeleton" style="width: 25%; height: 10px; border-radius: 4px; margin: 0 auto 8px auto;"></div>
                      <div class="skeleton" style="width: 85%; height: 18px; border-radius: 4px; margin: 0 auto;"></div>
                    </div>
                    <div class="info-item" style="margin-bottom: 20px;">
                      <div class="skeleton" style="width: 30%; height: 10px; border-radius: 4px; margin: 0 auto 8px auto;"></div>
                      <div class="skeleton" style="width: 75%; height: 18px; border-radius: 4px; margin: 0 auto;"></div>
                    </div>
                    <div class="info-item row" style="margin-bottom: 0;">
                      <div class="col s6">
                        <div class="skeleton" style="width: 40%; height: 10px; border-radius: 4px; margin: 0 auto 8px auto;"></div>
                        <div class="skeleton" style="width: 60%; height: 18px; border-radius: 4px; margin: 0 auto;"></div>
                      </div>
                      <div class="col s6">
                        <div class="skeleton" style="width: 30%; height: 10px; border-radius: 4px; margin: 0 auto 8px auto;"></div>
                        <div class="skeleton" style="width: 40%; height: 18px; border-radius: 4px; margin: 0 auto;"></div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="col s12 m6">
                <div class="card info-card z-depth-0">
                  <div class="card-content center-align">
                    <div class="skeleton" style="width: 55%; height: 24px; border-radius: 4px; margin: 0 auto 25px auto;"></div>
                    <div class="info-item row" style="margin-bottom: 20px;">
                      <div class="col s6">
                        <div class="skeleton" style="width: 35%; height: 10px; border-radius: 4px; margin: 0 auto 8px auto;"></div>
                        <div class="skeleton" style="width: 70%; height: 18px; border-radius: 4px; margin: 0 auto;"></div>
                      </div>
                      <div class="col s6">
                        <div class="skeleton" style="width: 25%; height: 10px; border-radius: 4px; margin: 0 auto 8px auto;"></div>
                        <div class="skeleton" style="width: 80%; height: 18px; border-radius: 4px; margin: 0 auto;"></div>
                      </div>
                    </div>
                    <div class="info-item" style="margin-bottom: 20px;">
                      <div class="skeleton" style="width: 25%; height: 10px; border-radius: 4px; margin: 0 auto 8px auto;"></div>
                      <div class="skeleton" style="width: 65%; height: 18px; border-radius: 4px; margin: 0 auto;"></div>
                    </div>
                    <div class="info-item" style="margin-bottom: 20px;">
                      <div class="skeleton" style="width: 45%; height: 10px; border-radius: 4px; margin: 0 auto 8px auto;"></div>
                      <div class="skeleton" style="width: 75%; height: 18px; border-radius: 4px; margin: 0 auto;"></div>
                    </div>
                    <div class="info-item row" style="margin-bottom: 20px;">
                      <div class="col s6">
                        <div class="skeleton" style="width: 55%; height: 10px; border-radius: 4px; margin: 0 auto 8px auto;"></div>
                        <div class="skeleton" style="width: 45%; height: 18px; border-radius: 4px; margin: 0 auto;"></div>
                      </div>
                      <div class="col s6">
                        <div class="skeleton" style="width: 50%; height: 10px; border-radius: 4px; margin: 0 auto 8px auto;"></div>
                        <div class="skeleton" style="width: 60%; height: 18px; border-radius: 4px; margin: 0 auto;"></div>
                      </div>
                    </div>
                    <div class="info-item" style="margin-bottom: 20px;">
                      <div class="skeleton" style="width: 45%; height: 10px; border-radius: 4px; margin: 0 auto 8px auto;"></div>
                      <div class="skeleton" style="width: 25%; height: 18px; border-radius: 4px; margin: 0 auto;"></div>
                    </div>
                    <div class="info-item row" style="margin-bottom: 15px;">
                      <div class="col s6">
                        <div class="skeleton" style="width: 40%; height: 10px; border-radius: 4px; margin: 0 auto 8px auto;"></div>
                        <div class="skeleton" style="width: 30%; height: 18px; border-radius: 4px; margin: 0 auto;"></div>
                      </div>
                      <div class="col s6">
                        <div class="skeleton" style="width: 40%; height: 10px; border-radius: 4px; margin: 0 auto 8px auto;"></div>
                        <div class="skeleton" style="width: 45%; height: 18px; border-radius: 4px; margin: 0 auto;"></div>
                      </div>
                    </div>
                    <div class="info-item card-panel grey lighten-5 z-depth-0" style="padding: 15px; margin-top: 15px;">
                      <div class="skeleton" style="width: 40%; height: 12px; border-radius: 4px; margin: 0 auto 16px auto;"></div>
                      <div class="row" style="margin-bottom: 0;">
                        <div class="col s6">
                          <div class="skeleton" style="width: 20%; height: 9px; border-radius: 4px; margin: 0 auto 6px auto;"></div>
                          <div class="skeleton" style="width: 75%; height: 16px; border-radius: 4px; margin: 0 auto;"></div>
                        </div>
                        <div class="col s6">
                          <div class="skeleton" style="width: 25%; height: 9px; border-radius: 4px; margin: 0 auto 6px auto;"></div>
                          <div class="skeleton" style="width: 75%; height: 16px; border-radius: 4px; margin: 0 auto;"></div>
                        </div>
                        <div class="col s6" style="margin-top: 14px;">
                          <div class="skeleton" style="width: 35%; height: 9px; border-radius: 4px; margin: 0 auto 6px auto;"></div>
                          <div class="skeleton" style="width: 80%; height: 16px; border-radius: 4px; margin: 0 auto;"></div>
                        </div>
                        <div class="col s6" style="margin-top: 14px;">
                          <div class="skeleton" style="width: 40%; height: 9px; border-radius: 4px; margin: 0 auto 6px auto;"></div>
                          <div class="skeleton" style="width: 85%; height: 16px; border-radius: 4px; margin: 0 auto;"></div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="content" v-show="!detailsLoader">
            <div class="row profile-hero center-align">
              <div class="col s12">
                <img :src="getPhoto(employeeModal.profile_photo) || ''" class="profile-avatar" alt="Profile Photo">
                <h4 class="employee-name">
                  {{ employeeModal.first_name }} {{ employeeModal.middle_name ? employeeModal.middle_name + ' ' : '' }}{{ employeeModal.last_name }}
                </h4>
                <div class="employee-badge blue darken-1 white-text" style="padding: 5px 15px; border-radius: 20px; display: inline-block;">
                  LTO ID: <b>{{ employeeModal.employee_id_number }}</b>
                </div>

                <!-- RESET PASSWORD BUTTON -->
                <div v-if="currentUser['id'] === 1" style="margin-top: 15px;">
                  <button @click="openResetPasswordModal" class="btn-small red darken-1 z-depth-1" style="border-radius: 20px; font-weight: bold; text-transform: none;">
                    <i class="material-icons left" style="font-size: 1.2rem; margin-right: 5px;">vpn_key</i> Reset Password
                  </button>
                </div>

              </div>
            </div>

            <div class="row">
              <div class="col s12 m6">
                <div class="card info-card z-depth-0">
                  <div class="card-content">
                    <h5 class="info-card-title blue-text text-darken-2">Personal Information</h5>
                    <div class="info-item">
                      <span class="info-label">Mobile Number</span>
                      <div class="info-value"><b>{{ employeeModal.cellphone_number || 'N/A' }}</b></div>
                    </div>
                    <div class="info-item">
                      <span class="info-label">Email Address</span>
                      <div class="info-value"><b>{{ employeeModal.user?.email || 'N/A' }}</b></div>
                    </div>
                    <div class="info-item">
                      <span class="info-label">Address</span>
                      <div class="info-value"><b>{{ employeeModal.address || 'N/A' }}</b></div>
                    </div>
                    <div class="info-item">
                      <span class="info-label">Birthplace</span>
                      <div class="info-value"><b>{{ employeeModal.birthplace || 'N/A' }}</b></div>
                    </div>
                    <div class="info-item row" style="margin-bottom: 0;">
                      <div class="col s6" style="padding-left: 0;">
                        <span class="info-label">Birthday</span>
                        <div class="info-value"><b>{{ formatDate(employeeModal.birthday) }}</b></div>
                      </div>
                      <div class="col s6">
                        <span class="info-label">Sex</span>
                        <div class="info-value"><b>{{ employeeModal.sex || 'N/A' }}</b></div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              
              <div class="col s12 m6">
                <div class="card info-card z-depth-0">
                  <div class="card-content">
                    <h5 class="info-card-title green-text text-darken-2">Employment Details</h5>
                    <div class="info-item">
                        <span class="info-label">Service Status</span>
                        <div class="info-value">
                          <span :class="employeeModal.service_status?.id === 1 ? 'green' : 'red darken-1'" data-badge-caption="" style="margin-left: 0; border-radius: 4px; padding: 2px 8px;">
                            <b>{{ employeeModal.service_status?.name || 'N/A' }}</b>
                          </span>
                        </div>
                    </div>
                    <div class="info-item row" style="margin-bottom: 20px;">
                      <div class="col s6" style="padding-left: 0;">
                        <span class="info-label">Position</span>
                        <div class="info-value"><b>{{ employeeModal.position?.title || 'N/A' }}</b></div>
                      </div>
                      <div class="col s6">
                        <span class="info-label">Item</span>
                        <div class="info-value"><b>{{ employeeModal.item_number || 'N/A' }}</b></div>
                      </div>
                    </div>
                    <div class="info-item">
                        <span class="info-label">Plantilla</span>
                        <div class="info-value"><b>{{ employeeModal.plantilla?.name || 'N/A' }}</b></div>
                    </div>
                    <div class="info-item">
                        <span class="info-label">Current Office Assigned</span>
                        <div class="info-value"><b>{{ employeeModal.assigned_office?.name || 'N/A' }}</b></div>
                    </div>
                    <div class="info-item row" style="margin-bottom: 20px;">
                      <div class="col s6" style="padding-left: 0;">
                        <span class="info-label">Employment Status</span>
                        <div class="info-value"><b>{{ employeeModal.employment_status?.name || 'N/A' }}</b></div>
                      </div>
                      <div class="col s6">
                        <span class="info-label">{{ employeeModal.employment_status?.id === 3 ? 'Date Hired' : 'Employment Date' }}</span>
                        <div class="info-value"><b>{{ formatDate(employeeModal.effectivity_date) }}</b></div>
                      </div>
                    </div>
                    <div class="info-item">
                      <span class="info-label">Civil Service Eligibility</span>
                      <div class="info-value"><b>{{ employeeModal.eligibility?.name || 'N/A' }}</b></div>
                    </div>
                    <div class="info-item row" style="margin-bottom: 0;">
                      <div class="col s6" style="padding-left: 0;">
                        <span class="info-label">Salary Grade</span>
                        <div class="info-value"><b>{{ employeeModal.salary_grade ? 'SG '+ employeeModal.salary_grade.grade : 'N/A' }}</b></div>
                      </div>
                      <div class="col s6">
                        <span class="info-label">Base Salary</span>
                        <div class="info-value"><b>₱{{ formatCurrency(employeeModal.salary_grade ? employeeModal.salary_grade.salary_amount : employeeModal.base_salary) }}</b></div>
                      </div>
                    </div>
                    
                    <div class="info-item card-panel grey lighten-5 z-depth-0 center-align" style="padding: 15px; margin-top: 15px; border: 1px solid #e0e0e0;">
                      <span class="info-label" style="margin-bottom: 15px;">Government IDs</span>
                      
                      <div class="row" style="margin-bottom: 0;">
                        <div class="col s12 m4" style="margin-bottom: 15px;">
                          <span class="info-label" style="font-size: 0.75rem;">TIN</span>
                          <div class="info-value" style="font-size: 0.95rem; white-space: nowrap;"><b>{{ employeeModal.tin || 'N/A' }}</b></div>
                        </div>
                        <div class="col s12 m4" style="margin-bottom: 15px;">
                          <span class="info-label" style="font-size: 0.75rem;">SSS</span>
                          <div class="info-value" style="font-size: 0.95rem; white-space: nowrap;"><b>{{ employeeModal.sss || 'N/A' }}</b></div>
                        </div>
                        <div class="col s12 m4" style="margin-bottom: 15px;">
                          <span class="info-label" style="font-size: 0.75rem;">GSIS</span>
                          <div class="info-value" style="font-size: 0.95rem; white-space: nowrap;"><b>{{ employeeModal.gsis || 'N/A' }}</b></div>
                        </div>
                        <div class="col s12 m6" style="margin-bottom: 10px;">
                          <span class="info-label" style="font-size: 0.75rem;">Pag-IBIG</span>
                          <div class="info-value" style="font-size: 0.95rem; white-space: nowrap;"><b>{{ employeeModal.pagibig || 'N/A' }}</b></div>
                        </div>
                        <div class="col s12 m6" style="margin-bottom: 10px;">
                          <span class="info-label" style="font-size: 0.75rem;">PhilHealth</span>
                          <div class="info-value" style="font-size: 0.95rem; white-space: nowrap;"><b>{{ employeeModal.philhealth || 'N/A' }}</b></div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            
            <div class="row" style="margin-bottom: 20px; padding-top: 10px;">
              <div class="col s12 center-align grey-text text-darken-1">
                <i class="material-icons" style="font-size: 1.1rem; vertical-align: text-bottom;">history</i>
                <span style="font-size: 0.95rem; margin-left: 5px;">
                  Record created on <b>{{ formatDate(employeeModal.created_at) }}</b>
                  <span v-if="employeeModal.creator">
                     by <b>{{ employeeModal.creator.username || employeeModal.creator.email }}</b>
                  </span>
                </span>
              </div>
            </div>

          </div>
        </div>
      </div>
    </div>

    <!-- Edit Div -->
    <div id="editDiv" class="modal modal-fixed-footer main-modal">
      
      <div class="modal-content white lighten-4" style="padding: 0;">
        
        <div class="modal-header blue" style="display: flex; justify-content: space-between; align-items: center; padding: 15px 24px; position: sticky; top: 0; z-index: 10;">
          <h5 class="white-text" style="margin: 0; font-weight: 600;">Edit Employee Information</h5>
          <a href="#!" class="modal-close white-text close-x-btn" style="display: flex; align-items: center; justify-content: center; padding: 4px; border-radius: 50%;">
            <i class="material-icons" style="font-size: 2rem;">close</i>
          </a>
        </div>

        <div style="padding: 24px;">
          <!-- SKELETON LOADING -->
          <div class="content-skeleton" v-show="detailsLoader">
            <div class="skeleton" style="width: 180px; height: 16px; border-radius: 4px; margin-top: 20px; margin-bottom: 20px;"></div>
            <div class="row">
              <div class="input-field col s12 m4" v-for="n in 3" :key="'skel-pi1-' + n">
                <div class="skeleton" style="width: 40%; height: 10px; border-radius: 4px; margin-bottom: 8px;"></div>
                <div class="skeleton" style="width: 100%; height: 2.5rem; border-radius: 4px; margin-bottom: 15px;"></div>
              </div>
            </div>
            <div class="row">
              <div class="input-field col s12 m4" v-for="n in 3" :key="'skel-pi2-' + n">
                <div class="skeleton" style="width: 35%; height: 10px; border-radius: 4px; margin-bottom: 8px;"></div>
                <div class="skeleton" style="width: 100%; height: 2.5rem; border-radius: 4px; margin-bottom: 15px;"></div>
              </div>
            </div>
            <div class="row">
              <div class="input-field col s12 m6" v-for="n in 2" :key="'skel-pi3-' + n">
                <div class="skeleton" style="width: 25%; height: 10px; border-radius: 4px; margin-bottom: 8px;"></div>
                <div class="skeleton" style="width: 100%; height: 2.5rem; border-radius: 4px; margin-bottom: 15px;"></div>
              </div>
            </div>
            <div class="divider" style="margin: 20px 0;"></div>
            <div class="row">
              <div class="col s12 m6" v-for="n in 2" :key="'skel-addr-' + n">
                <div class="card-panel z-depth-0" style="border: 1px solid #e0e0e0; height: 115px;">
                  <div class="skeleton" style="width: 60%; height: 14px; border-radius: 4px; margin: 0 auto 25px auto;"></div>
                  <div class="skeleton" style="width: 90%; height: 12px; border-radius: 4px; margin: 0 auto 8px auto;"></div>
                  <div class="skeleton" style="width: 70%; height: 12px; border-radius: 4px; margin: 0 auto;"></div>
                </div>
              </div>
            </div>
            <div class="divider" style="margin: 20px 0;"></div>
            <div class="skeleton" style="width: 180px; height: 16px; border-radius: 4px; margin-top: 20px; margin-bottom: 20px;"></div>
            <div class="row">
              <div class="input-field col s12 m6" v-for="n in 8" :key="'skel-emp1-' + n">
                <div class="skeleton" style="width: 35%; height: 10px; border-radius: 4px; margin-bottom: 8px;"></div>
                <div class="skeleton" style="width: 100%; height: 2.5rem; border-radius: 4px; margin-bottom: 15px;"></div>
              </div>
              <div class="input-field col s12 m3" v-for="n in 2" :key="'skel-emp2-' + n">
                <div class="skeleton" style="width: 45%; height: 10px; border-radius: 4px; margin-bottom: 8px;"></div>
                <div class="skeleton" style="width: 100%; height: 2.5rem; border-radius: 4px; margin-bottom: 15px;"></div>
              </div>
              <div class="input-field col s12 m6">
                <div class="skeleton" style="width: 30%; height: 10px; border-radius: 4px; margin-bottom: 8px;"></div>
                <div class="skeleton" style="width: 100%; height: 2.5rem; border-radius: 4px; margin-bottom: 15px;"></div>
              </div>
            </div>
            <div class="divider" style="margin: 20px 0;"></div>
            <div class="skeleton" style="width: 150px; height: 16px; border-radius: 4px; margin-top: 20px; margin-bottom: 20px;"></div>
            <div class="row">
              <div class="input-field col s6 m3" v-for="n in 4" :key="'skel-gov-' + n">
                <div class="skeleton" style="width: 30%; height: 10px; border-radius: 4px; margin-bottom: 8px;"></div>
                <div class="skeleton" style="width: 100%; height: 2.5rem; border-radius: 4px; margin-bottom: 15px;"></div>
              </div>
            </div>
          </div>

          <!-- AFTER SKELETON LOADING -->
          <form id="editEmployeeForm" @submit.prevent="submitEditForm" v-show="!detailsLoader">
                    
              <h6 class="blue-text text-darken-2" style="font-weight: bold; margin-top: 20px;">Personal Information</h6>
              <div class="row">
                <div class="input-field col s12 m4">
                  <input id="edit_first_name" type="text" ref="first_name" v-model="editForm.first_name" :class="{'invalid': editErrors.first_name}" @input="capitalize('first_name'); editErrors.first_name=''" required>
                  <label class="active" for="edit_first_name">First Name</label>
                  <span class="helper-text left-align" :data-error="editErrors.first_name" style="position: absolute; top: 100%; left: 10px; width: 100%;"></span>
                </div>
                <div class="input-field col s12 m4">
                  <input id="edit_middle_name" type="text" ref="middle_name" v-model="editForm.middle_name" :class="{'invalid': editErrors.middle_name}" @input="capitalize('middle_name'); editErrors.middle_name=''">
                  <label class="active" for="edit_middle_name">Middle Name</label>
                  <span class="helper-text left-align" :data-error="editErrors.middle_name" style="position: absolute; top: 100%; left: 10px; width: 100%;"></span>
                </div>
                <div class="input-field col s12 m4">
                  <input id="edit_last_name" type="text" ref="last_name" v-model="editForm.last_name" :class="{'invalid': editErrors.last_name}" @input="capitalize('last_name'); editErrors.last_name=''" required>
                  <label class="active" for="edit_last_name">Last Name</label>
                  <span class="helper-text left-align" :data-error="editErrors.last_name" style="position: absolute; top: 100%; left: 10px; width: 100%;"></span>
                </div>
              </div>

              <div class="row">
                <div class="input-field col s12 m4">
                  <input id="edit_email" type="email" ref="email" v-model="editForm.email" :class="{'invalid': editErrors.email}" @input="editErrors.email=''" required>
                  <label class="active" for="edit_email">Email Address</label>
                  <span class="helper-text left-align" :data-error="editErrors.email" style="position: absolute; top: 100%; left: 10px; width: 100%;"></span>
                </div>
                <div class="input-field col s12 m4">
                  <input id="edit_username" type="text" ref="username" v-model="editForm.username" :class="{'invalid': editErrors.username}" @input="editErrors.username=''" required>
                  <label class="active" for="edit_username">Username</label>
                  <span class="helper-text left-align" :data-error="editErrors.username" style="position: absolute; top: 100%; left: 10px; width: 100%;"></span>
                </div>
                <div class="input-field col s12 m4">
                  <input id="edit_cellphone" type="text" ref="cellphone_number" v-model="editForm.cellphone_number" :class="{'invalid': editErrors.cellphone_number}" @input="editForm.cellphone_number = formatNumber(editForm.cellphone_number, '0000-000-0000'); editErrors.cellphone_number=''" minlength="13" maxlength="13" required>
                  <label class="active" for="edit_cellphone">Mobile Number</label>
                  <span class="helper-text left-align" :data-error="editErrors.cellphone_number" style="position: absolute; top: 100%; left: 10px; width: 100%;"></span>
                </div>
              </div>

              <div class="row">
                <div class="input-field col s12 m6">
                  <input id="edit_birthday" type="date" ref="birthday" v-model="editForm.birthday" :class="{'invalid': editErrors.birthday}" @change="editErrors.birthday=''" required>
                  <label for="edit_birthday" class="active">Birthday</label>
                  <span class="helper-text left-align" :data-error="editErrors.birthday" style="position: absolute; top: 100%; left: 10px; width: 100%;"></span>
                </div>
                <div class="input-field col s12 m6">
                  <select class="browser-default" ref="sex" v-model="editForm.sex" @change="editErrors.sex=''" :style="editErrors.sex ? 'border-color: #F44336;' : 'border-bottom: 1px solid #9e9e9e; border-top: none; border-left: none; border-right: none; background-color: transparent;'" required>
                    <option value="" disabled>Select Sex</option>
                    <option value="Male">Male</option>
                    <option value="Female">Female</option>
                  </select>
                  <span class="helper-text left-align red-text" v-show="editErrors.sex" style="position: absolute; top: 100%; left: 10px; width: 100%; font-size: 12px;">{{ editErrors.sex }}</span>
                </div>
              </div>

              <div class="divider" style="margin: 20px 0;"></div>

          <div class="row">
            
            <div class="col s12 m6">
              <div class="card-panel z-depth-0" style="border: 1px solid #e0e0e0; position: relative;">
                <div class="titleWithButton" style="display: flex; justify-content: center; align-items: center; flex-direction: row; gap: 15px;">
                  <h6 style="font-weight: bold; margin-bottom: 25px; margin-top: 0;">Permanent / Current Address</h6>
                  
                  <button type="button" @click="resetAddress('current')" class="btn red lighten-1" style="border-radius: 4px; scale: 0.7; margin-top: -25px;">
                    <i class="material-icons left" style="margin-right: 5px;">{{ caEdit ? 'close' : 'edit' }}</i>
                  </button>
                  
                  <button v-show="caEdit" type="button" @click="saveAddress('current')" class="btn green lighten-1" style="border-radius: 4px; scale: 0.7; margin-top: -25px; margin-left: -15px;">
                    <i class="material-icons left" style="margin-right: 5px;">check</i>
                  </button>
                  
                  <button v-show="!caEdit && originalEditForm && editForm.address !== originalEditForm.address" type="button" @click="undoAddress('current')" class="btn orange darken-2" style="border-radius: 4px; scale: 0.7; margin-top: -25px; margin-left: -15px;" title="Undo Changes">
                    <i class="material-icons left" style="margin-right: 5px;">undo</i>
                  </button>
                  
                </div>

                <p style="color: red; margin-top: 0;">{{ errors.caddress }}</p>

                <h6 v-show="!caEdit">{{ editForm.address }}</h6>

                <div class="c-address-edit" v-show="caEdit">                 
                  <div class="input-field">
                    <input type="text" id="edit_region" list="edit_region-list" v-model="editForm.region" @blur="handleRegionChange('current')" autocomplete="off" required>
                    <label for="edit_region" :class="{ active: editForm.region }">Region</label>
                    <datalist id="edit_region-list">
                      <option v-for="r in regions" :value="r.name" :key="r.code"></option>
                    </datalist>
                  </div>

                  <div class="input-field">
                    <input type="text" id="edit_province" list="edit_province-list" v-model="editForm.province" @blur="handleProvinceChange('current')" autocomplete="off" :disabled="!editForm.region" required>
                    <label for="edit_province" :class="{ active: editForm.province }">Province</label>
                    <datalist id="edit_province-list">
                      <option v-for="p in provinces" :value="p.name" :key="p.code"></option>
                    </datalist>
                  </div>

                  <div class="input-field">
                    <input type="text" id="edit_city" list="edit_city-list" v-model="editForm.city_or_municipality" @blur="handleCityChange('current')" autocomplete="off" :disabled="!editForm.province" required>
                    <label for="edit_city" :class="{ active: editForm.city_or_municipality }">City or Municipality</label>
                    <datalist id="edit_city-list">
                      <option v-for="c in cities_or_municipalities" :value="c.name" :key="c.code"></option>
                    </datalist>
                  </div>

                  <div class="input-field">
                    <input type="text" id="edit_barangay" list="edit_brgy-list" v-model="editForm.barangay" autocomplete="off" :disabled="!editForm.city_or_municipality" required>
                    <label for="edit_barangay" :class="{ active: editForm.barangay }">Barangay</label>
                    <datalist id="edit_brgy-list">
                      <option v-for="b in barangays" :value="b.name" :key="b.code"></option>
                    </datalist>
                  </div>
                </div>
              </div>
            </div>

            <!-- BIRTHPLACE COLUMN -->
            <div class="col s12 m6">
              <div class="card-panel z-depth-0" style="border: 1px solid #e0e0e0; position: relative;">
                <div class="titleWithButton" style="display: flex; justify-content: center; align-items: center; flex-direction: row; gap: 15px;">
                  <h6 style="font-weight: bold; margin-bottom: 25px; margin-top: 0;">Birthplace</h6>
                  
                  <button type="button" @click="resetAddress('bp')" class="btn red lighten-1" style="border-radius: 4px; scale: 0.7; margin-top: -25px;">
                    <i class="material-icons left" style="margin-right: 5px;">{{ bpEdit ? 'close' : 'edit' }}</i>
                  </button>
                  
                  <button v-show="bpEdit" type="button" @click="saveAddress('bp')" class="btn green lighten-1" style="border-radius: 4px; scale: 0.7; margin-top: -25px; margin-left: -15px;">
                    <i class="material-icons left" style="margin-right: 5px;">check</i>
                  </button>

                  <button v-show="!bpEdit && originalEditForm && editForm.birthplace !== originalEditForm.birthplace" type="button" @click="undoAddress('bp')" class="btn orange darken-2" style="border-radius: 4px; scale: 0.7; margin-top: -25px; margin-left: -15px;" title="Undo Changes">
                    <i class="material-icons left" style="margin-right: 5px;">undo</i>
                  </button>
                  
                </div>

                <p style="color: red; margin-top: 0;">{{ errors.baddress }}</p>

                <h6 v-show="!bpEdit">{{ editForm.birthplace }}</h6>

                <div class="c-address-edit" v-show="bpEdit">                 
                  <div class="input-field">
                    <input type="text" id="edit_bp_region" list="edit_bp_region-list" v-model="editForm.bp_region" @blur="handleRegionChange('bp')" autocomplete="off" required>
                    <label for="edit_bp_region" :class="{ active: editForm.bp_region }">Region</label>
                    <datalist id="edit_bp_region-list">
                      <option v-for="r in regions" :value="r.name" :key="r.code"></option>
                    </datalist>
                  </div>

                  <div class="input-field">
                    <input type="text" id="edit_bp_province" list="edit_bp_province-list" v-model="editForm.bp_province" @blur="handleProvinceChange('bp')" autocomplete="off" :disabled="!editForm.bp_region" required>
                    <label for="edit_bp_province" :class="{ active: editForm.bp_province }">Province</label>
                    <datalist id="edit_bp_province-list">
                      <option v-for="p in bp_provinces" :value="p.name" :key="p.code"></option>
                    </datalist>
                  </div>

                  <div class="input-field">
                    <input type="text" id="edit_bp_city" list="edit_bp_city-list" v-model="editForm.bp_city_or_municipality" @blur="handleCityChange('bp')" autocomplete="off" :disabled="!editForm.bp_province" required>
                    <label for="edit_bp_city" :class="{ active: editForm.bp_city_or_municipality }">City or Municipality</label>
                    <datalist id="edit_bp_city-list">
                      <option v-for="c in bp_cities" :value="c.name" :key="c.code"></option>
                    </datalist>
                  </div>

                  <div class="input-field">
                    <input type="text" id="edit_bp_barangay" list="edit_bp_brgy-list" v-model="editForm.bp_barangay" autocomplete="off" :disabled="!editForm.bp_city_or_municipality" required>
                    <label for="edit_bp_barangay" :class="{ active: editForm.bp_barangay }">Barangay</label>
                    <datalist id="edit_bp_brgy-list">
                      <option v-for="b in bp_barangays" :value="b.name" :key="b.code"></option>
                    </datalist>
                  </div>
                </div>
              </div>
            </div>
            
            </div>

              <div class="divider" style="margin: 20px 0;"></div>
              <h6 class="green-text text-darken-2" style="font-weight: bold; margin-top: 30px;">Employment Details</h6>

              <div class="row">
                <div class="input-field col s12">
                  <select class="browser-default" ref="service_status_id" v-model="editForm.service_status_id" @change="editErrors.service_status_id=''" :style="editErrors.service_status_id ? 'border: 1px solid #F44336;' : 'border: 1px solid #ccc;'" style="border-radius: 4px; padding: 5px;" required>
                    <option value="" disabled>Select Service Status</option>
                    <option v-for="status in dropdowns.serviceStatuses" :key="status.id" :value="status.id">{{ status.name }}</option>
                  </select>
                  <label class="active" style="transform:  translateY(-19px) scale(0.8);">Service Status</label>
                  <span class="helper-text left-align red-text" v-show="editErrors.service_status_id" style="position: absolute; top: 100%; left: 10px; width: 100%; font-size: 12px;">{{ editErrors.service_status_id }}</span>
                </div>

                <div class="input-field col s12 m6">
                  <select class="browser-default" ref="employment_status_id" v-model="editForm.employment_status_id" @change="editErrors.employment_status_id=''" :style="editErrors.employment_status_id ? 'border: 1px solid #F44336;' : 'border: 1px solid #ccc;'" style="border-radius: 4px; padding: 5px;" required>
                    <option value="" disabled>Select Status</option>
                    <option v-for="status in dropdowns.employmentStatuses" :key="status.id" :value="status.id">{{ status.name }}</option>
                  </select>
                  <label class="active" style="transform: translateY(-19px) scale(0.8);">Employment Status</label>
                  <span class="helper-text left-align red-text" v-show="editErrors.employment_status_id" style="position: absolute; top: 100%; left: 10px; width: 100%; font-size: 12px;">{{ editErrors.employment_status_id }}</span>
                </div>

                

                <div class="input-field col s12 m6" style="display: flex; align-items: center; transition: all 0.2s ease; position: relative;">
                  <span style="padding-right: 6px; color: #424242; font-size: 1.3rem; margin-bottom: 0; white-space: nowrap;">
                      {{ editForm.employment_status_id == 3 ? 'LTO-COS-' : 'LTO-RO2-' }}
                  </span>
                  <input id="edit_lto_id" type="text" ref="employee_id_number" v-model="editForm.employee_id_number" :class="{'invalid': editErrors.employee_id_number}" @input="editForm.employee_id_number = formatNumber(editForm.employee_id_number, '000'); editErrors.employee_id_number=''" required style="margin: 0 !important; height: 3rem; flex: 1; font-size: 1.2rem;">
                  <label class="active" for="edit_lto_id">LTO ID Number</label>
                  <span class="helper-text left-align" :data-error="editErrors.employee_id_number" style="position: absolute; top: 100%; left: 10px; width: 100%;"></span>
                </div>
                
                <div class="input-field col s12 m6">
                  <select class="browser-default" ref="plantilla_id" v-model="editForm.plantilla_id" @change="editErrors.plantilla_id=''" :style="editErrors.plantilla_id ? 'border: 1px solid #F44336;' : 'border: 1px solid #ccc;'" style="border-radius: 4px; padding: 5px;" required>
                    <option value="" disabled>Select Plantilla</option>
                    <option v-for="plantilla in dropdowns.plantillas" :key="plantilla.id" :value="plantilla.id">{{ plantilla.name }}</option>
                  </select>
                  <label class="active" style="transform: translateY(-19px) scale(0.8);">Plantilla</label>
                  <span class="helper-text left-align red-text" v-show="editErrors.plantilla_id" style="position: absolute; top: 100%; left: 10px; width: 100%; font-size: 12px;">{{ editErrors.plantilla_id }}</span>
                </div>

                <div class="input-field col s12 m6" style="display: flex; align-items: center; transition: all 0.2s ease; position: relative;">
                  <span v-show="editForm.employment_status_id !== 3" style="padding-right: 6px; color: #424242; font-size: 1.2rem; margin-bottom: 0; white-space: nowrap;">
                      OSEC-DOTrB-
                  </span>
                  <input id="edit_item_number" type="text" ref="item_number" v-model="editForm.item_number" :class="{'invalid': editErrors.item_number}" @input="editErrors.item_number=''" :disabled="editForm.employment_status_id === 3" :placeholder="editForm.employment_status_id === 3 ? 'N/A' : 'Item Number'" :required="editForm.employment_status_id !== 3" style="margin: 0 !important; height: 3rem; flex: 1; font-size: 1.2rem;">
                  <label class="active" for="edit_item_number">Item Number</label>
                  <span class="helper-text left-align" :data-error="editErrors.item_number" style="position: absolute; top: 100%; left: 10px; width: 100%;"></span>
                </div>
                
                <div class="input-field col s12 m6">
                  <select class="browser-default" ref="eligibility_id" v-model="editForm.eligibility_id" @change="editErrors.eligibility_id=''" :style="editErrors.eligibility_id ? 'border: 1px solid #F44336;' : 'border: 1px solid #ccc;'" style="border-radius: 4px; padding: 5px;" required>
                    <option value="" disabled>Select Eligibility</option>
                    <option v-for="elig in dropdowns.eligibilities" :key="elig.id" :value="elig.id">{{ elig.name }}</option>
                  </select>
                  <label class="active" style="transform: translateY(-19px) scale(0.8);">Eligibility</label>
                  <span class="helper-text left-align red-text" v-show="editErrors.eligibility_id" style="position: absolute; top: 100%; left: 10px; width: 100%; font-size: 12px;">{{ editErrors.eligibility_id }}</span>
                </div>

                <div class="input-field col s12 m6">
                  <select class="browser-default" ref="position_id" v-model="editForm.position_id" @change="handleEditPositionChange(); editErrors.position_id=''" :style="editErrors.position_id ? 'border: 1px solid #F44336;' : 'border: 1px solid #ccc;'" style="border-radius: 4px; padding: 5px;" required>
                    <option value="" disabled>Select Position Title</option>
                    <option v-for="pos in dropdowns.positions" :key="pos.id" :value="pos.id">{{ pos.title }}</option>
                  </select>
                  <label class="active" style="transform: translateY(-19px) scale(0.8);">Position</label>
                  <span class="helper-text left-align red-text" v-show="editErrors.position_id" style="position: absolute; top: 100%; left: 10px; width: 100%; font-size: 12px;">{{ editErrors.position_id }}</span>
                </div>

                <div class="input-field col s12 m6">
                  <select class="browser-default" ref="assigned_office_id" v-model="editForm.assigned_office_id" @change="editErrors.assigned_office_id=''" :style="editErrors.assigned_office_id ? 'border: 1px solid #F44336;' : 'border: 1px solid #ccc;'" style="border-radius: 4px; padding: 5px;" required>
                    <option value="" disabled>Select Assigned Office</option>
                    <option v-for="office in dropdowns.offices" :key="office.id" :value="office.id">{{ office.name }}</option>
                  </select>
                  <label class="active" style="transform: translateY(-19px) scale(0.8);">Assigned Office</label>
                  <span class="helper-text left-align red-text" v-show="editErrors.assigned_office_id" style="position: absolute; top: 100%; left: 10px; width: 100%; font-size: 12px;">{{ editErrors.assigned_office_id }}</span>
                </div>

                <div class="input-field col s12 m6">
                  <input id="edit_effectivity_date" type="date" ref="effectivity_date" v-model="editForm.effectivity_date" :class="{'invalid': editErrors.effectivity_date}" @change="editErrors.effectivity_date=''" required>
                  <label for="edit_effectivity_date" class="active">Effectivity / Date Hired</label>
                  <span class="helper-text left-align" :data-error="editErrors.effectivity_date" style="position: absolute; top: 100%; left: 10px; width: 100%;"></span>
                </div>

                <div class="input-field col s12 m3" v-show="editForm.employment_status_id != 3">
                  <input id="edit_sg_display" type="text" :value="editForm.position_id ? 'SG ' + editForm.salary_grade_display : 'N/A'" placeholder="N/A" readonly>
                  <label class="active" for="edit_sg_display">Salary Grade</label>
                  <input type="hidden" v-model="editForm.salary_grade">
                </div>

                <div class="input-field col s12 m3" v-show="editForm.employment_status_id != 3">
                  <select class="browser-default" ref="salary_step" id="edit_salary_step" v-model="editForm.salary_step" @change="loadEditSalaryAmount(); editErrors.salary_step=''" :style="editErrors.salary_step ? 'border: 1px solid #F44336;' : 'border: 1px solid #ccc;'" style="border-radius: 4px; padding: 5px; height: 3rem;" :disabled="!editForm.salary_grade" :required="editForm.employment_status_id != 3">
                    <option value="" disabled>Select Step</option>
                    <option v-for="salaryStep in dropdowns.salarySteps" :key="salaryStep.step" :value="salaryStep.step">STEP {{ salaryStep.step }}</option>
                  </select>
                  <label class="active" style="transform: translateY(-19px) scale(0.8);">Salary Step</label>
                  <span class="helper-text left-align red-text" v-show="editErrors.salary_step" style="position: absolute; top: 100%; left: 10px; width: 100%; font-size: 12px;">{{ editErrors.salary_step }}</span>
                </div>

                <div class="input-field col s12 m6" v-show="editForm.employment_status_id != 3">
                  <span style="position: absolute; left: 5px; top: 10px; color: #424242; font-size: 1.2rem; z-index: 1;">₱</span>
                  <input id="edit_sa_display" type="text" :value="formatCurrency(editForm.editSalaryAmount)" placeholder="00.00" readonly style="padding-left: 15px !important; margin: 0 !important; height: 3rem; font-size: 1.2rem; box-sizing: border-box;">
                  <label class="active" for="edit_sa_display">Base Salary</label>
                </div>

                <div class="input-field col s12 m6" v-show="editForm.employment_status_id == 3">
                  <span style="position: absolute; left: 5px; top: 10px; color: #424242; font-size: 1.2rem; z-index: 1;">₱</span>
                  <input id="edit_base_salary_manual" ref="base_salary" type="number" step="1.00" v-model="editForm.base_salary" :class="{'invalid': editErrors.base_salary}" @input="editErrors.base_salary=''" :required="editForm.employment_status_id == 3" placeholder="00.00" style="padding-left: 15px !important; margin: 0 !important; height: 3rem; font-size: 1.2rem; box-sizing: border-box;">
                  <label class="active" for="edit_base_salary_manual">Base Salary</label>
                  <span class="helper-text left-align" :data-error="editErrors.base_salary" style="position: absolute; top: 100%; left: 10px; width: 100%;"></span>
                </div>
              </div>

              <div class="divider" style="margin: 20px 0;"></div>

              <h6 class="grey-text text-darken-3" style="font-weight: bold;">Government IDs</h6>
              <div class="row">
                <div class="input-field col s6 m4">
                  <input id="edit_tin" type="text" ref="tin" v-model="editForm.tin" :class="{'invalid': editErrors.tin}" @input="editForm.tin = formatNumber(editForm.tin, '000-000-000-000'); editErrors.tin=''" minlength="15" maxlength="15">
                  <label class="active" for="edit_tin">TIN</label>
                  <span class="helper-text left-align" :data-error="editErrors.tin" style="position: absolute; top: 100%; left: 10px; width: 100%;"></span>
                </div>
                <div class="input-field col s6 m4">
                  <input id="edit_gsis" type="text" ref="gsis" v-model="editForm.gsis" :class="{'invalid': editErrors.gsis}" @input="editForm.gsis = formatNumber(editForm.gsis, '00000000000'); editErrors.gsis=''" minlength="11" maxlength="11">
                  <label class="active" for="edit_gsis">GSIS</label>
                  <span class="helper-text left-align" :data-error="editErrors.gsis" style="position: absolute; top: 100%; left: 10px; width: 100%;"></span>
                </div>
                <div class="input-field col s6 m4">
                  <input id="edit_sss" type="text" ref="sss" v-model="editForm.sss" :class="{'invalid': editErrors.sss}" @input="editForm.sss = formatNumber(editForm.sss, '00-0000000-0'); editErrors.sss=''" minlength="12" maxlength="12">
                  <label class="active" for="edit_sss">SSS</label>
                  <span class="helper-text left-align" :data-error="editErrors.sss" style="position: absolute; top: 100%; left: 10px; width: 100%;"></span>
                </div>
                <div class="input-field col s6 m6">
                  <input id="edit_pagibig" type="text" ref="pagibig" v-model="editForm.pagibig" :class="{'invalid': editErrors.pagibig}" @input="editForm.pagibig = formatNumber(editForm.pagibig, '0000-0000-0000'); editErrors.pagibig=''" minlength="14" maxlength="14" required>
                  <label class="active" for="edit_pagibig">Pag-IBIG</label>
                  <span class="helper-text left-align" :data-error="editErrors.pagibig" style="position: absolute; top: 100%; left: 10px; width: 100%;"></span>
                </div>
                <div class="input-field col s6 m6">
                  <input id="edit_philhealth" type="text" ref="philhealth" v-model="editForm.philhealth" :class="{'invalid': editErrors.philhealth}" @input="editForm.philhealth = formatNumber(editForm.philhealth, '00-000000000-0'); editErrors.philhealth=''" minlength="14" maxlength="14" required>
                  <label class="active" for="edit_philhealth">PhilHealth</label>
                  <span class="helper-text left-align" :data-error="editErrors.philhealth" style="position: absolute; top: 100%; left: 10px; width: 100%;"></span>
                </div>
              </div>
          </form>
        </div>
      </div>

      <div class="modal-footer grey lighten-3 custom-footer">
        <a href="#!" class="modal-close btn-flat waves-grey left" style="margin: 0; padding: 0 10px;">Cancel</a>
        <button type="button" @click="submitEditForm" class="btn blue darken-1 right" :disabled="editLoader || !isEditFormChanged" style="border-radius: 6px;">
          <i class="material-icons left" v-if="!editLoader">save</i>
          <span v-if="editLoader">Saving...</span>
          <span v-else>Save Changes</span>
        </button>
      </div>
    </div>
    
    <div id="lockedDiv" class="modal" style="width: 90%; max-width: 450px; border-radius: 12px;">
      <div class="modal-content center-align" style="padding: 40px 24px 20px;">
        <i class="material-icons red-text" style="font-size: 4rem; margin-bottom: 10px;">lock</i>
        <h5 style="font-weight: 600;">Record Locked</h5>
        <p class="grey-text text-darken-2">This employee's information is currently locked. You must request to reopen the record before making any edits.</p>
        
        <div class="input-field" style="margin-top: 30px;">
          <textarea id="unlock_reason" class="materialize-textarea" v-model="unlockReason" required></textarea>
          <label for="unlock_reason">Reason for reopening (optional)</label>
        </div>
      </div>
      
      <div class="modal-footer custom-footer grey lighten-4">
        <a href="#!" class="modal-close btn-flat waves-grey left">Cancel</a>
        <button class="btn red darken-1 right" @click="submitUnlockRequest" :disabled="requestLoader" style="border-radius: 6px;">
          <span v-if="requestLoader">Sending...</span>
          <span v-else>Request Reopen</span>
        </button>
      </div>
    </div>

    <!-- Reset Password Modal -->
    <div id="resetPasswordDiv" class="modal centered-modal" style="width: 90%; max-width: 450px; border-radius: 12px;">
      <div class="modal-content" style="padding: 30px 24px;">
        <h5 class="red-text text-darken-1" style="font-weight: 600; margin-top: 0;">
          <i class="material-icons left" style="font-size: 2rem;">vpn_key</i> Reset Password
        </h5>
        <p>You are about to reset the password for <b>{{ employeeModal.first_name }} {{ employeeModal.last_name }}</b>.</p>

        <!-- Selection View -->
        <div v-if="!generatedPassword">
          <p class="grey-text text-darken-2">How would you like to deliver the new password?</p>
          <form action="#" style="margin-top: 20px;">
            <p>
              <label>
                <input name="resetOption" type="radio" value="email" v-model="resetOption" />
                <span class="black-text">Send via Email to <b>{{ employeeModal.user?.email || 'N/A' }}</b></span>
              </label>
            </p>
            <p>
              <label>
                <input name="resetOption" type="radio" value="screen" v-model="resetOption" />
                <span class="black-text">Show Password on Screen</span>
              </label>
            </p>
          </form>
        </div>

        <!-- Success View -->
        <div v-else class="card-panel green lighten-5 center-align" style="border: 1px dashed #4caf50; border-radius: 8px; margin-top: 25px;">
          <span class="green-text text-darken-3" style="font-weight: 600;">New Password Generated:</span>
          <h4 style="margin: 15px 0; font-family: monospace; font-weight: bold; letter-spacing: 2px; color: #1b5e20;">
            {{ generatedPassword }}
          </h4>
          <span class="grey-text text-darken-1" style="font-size: 0.85rem;">Please copy and securely share this with the employee.</span>
        </div>
      </div>
      
      <!-- REMOVED THE .modal-close CLASS FROM THIS FOOTER -->
      <div class="modal-footer grey lighten-4 custom-footer">
        <a href="#!" class="btn-flat waves-grey left" @click="closeResetModal">Close</a>
        <button v-if="!generatedPassword" class="btn red darken-1 right" @click="submitResetPassword" :disabled="resetLoader || !resetOption" style="border-radius: 6px;">
          <span v-if="resetLoader">Processing...</span>
          <span v-else>Confirm Reset</span>
        </button>
      </div>
    </div>

  </AdminAppLayout>
</template>

<style scoped>
/* OMITTED CSS TO SAVE SPACE - BUT IT STAYS EXACTLY THE SAME AS YOU PROVIDED! */
@media only screen and (max-width: 992px) {
  .main-modal { width: 95%; }
}
@media only screen and (min-width: 993px) {
  .main-modal { width: 80%; }
}

#search::placeholder {
  color: #4b4b4b;
  opacity: 1;
}

/* Enforce Strict Height for the Fixed Footer Modals */
.main-modal {
  border-radius: 20px;
  height: 85% !important;
  max-height: 85% !important;
}

/* Modal Content and Header Fixes */
.main-modal.modal-fixed-footer .modal-content {
  height: calc(100% - 65px) !important; 
}
.main-modal:not(.modal-fixed-footer) .modal-content {
  height: 100% !important;
}

.modal-header {
  border-bottom: 1px solid rgba(0,0,0,0.1);
}

/* Hover style for the top right close X button */
.close-x-btn {
  transition: background-color 0.2s ease;
}
.close-x-btn:hover {
  background-color: rgba(255, 255, 255, 0.2);
}

/* Custom Footer Overrides */
.custom-footer {
  display: flex !important;
  justify-content: space-between !important;
  align-items: center !important;
  padding: 0 24px !important;
  overflow: hidden !important; 
  border-radius: 0 0 20px 20px;
  height: 65px !important; 
}

.personalInfo .input-field, .employmentDetails .input-field {
  margin: 0 !important;
}

/* Hero Section */
.profile-hero {
  margin-top: 10px;
  margin-bottom: 30px;
}
.profile-avatar {
  width: 140px;
  height: 140px;
  object-fit: cover;
  border-radius: 50%;
  border: 4px solid #ffffff;
  box-shadow: 0 6px 16px rgba(0, 0, 0, 0.12);
  margin-bottom: 15px;
}
.employee-name {
  margin: 0 0 5px 0;
  font-weight: 600;
  font-size: 1.8rem;
  color: #212121;
}
.employee-badge {
  display: inline-block;
  padding: 6px 16px;
  border-radius: 20px;
  background-color: #e3f2fd; /* Light blue */
  color: #1565c0; /* Dark blue */
  font-weight: 600;
  font-size: 0.9rem;
  letter-spacing: 0.5px;
}

/* Info Cards */
.info-card {
  border-radius: 12px;
  border: 1px solid #eceff1;
  background-color: #ffffff;
}
.info-card-title {
  font-size: 1.25rem;
  font-weight: 600;
  margin-top: 0;
  padding-bottom: 15px;
  border-bottom: 2px solid #f5f5f5;
  margin-bottom: 20px;
}

/* Data Items */
.info-item {
  margin-bottom: 20px;
}
.info-label {
  display: block;
  font-size: 0.8rem;
  color: #9e9e9e;
  text-transform: uppercase;
  letter-spacing: 0.8px;
  font-weight: 600;
  margin-bottom: 4px;
}
.info-value {
  font-size: 1.1rem;
  color: #424242;
  font-weight: 500;
  line-height: 1.4;
}

tbody tr td {
  padding: 5px;
  font-size: 0.9rem;
}

thead th {
  font-size: 1rem;
  font-weight: bold;
}

.table-responsive-wrapper {
  overflow-x: auto;
  width: 100%;
  margin-bottom: 20px;
}

.table-responsive-wrapper table {
  min-width: 1000px;
}

.nowrap {
  white-space: nowrap;
}

tbody tr td {
  padding: 10px 5px;
  font-size: 1rem;
  vertical-align: middle;
}

thead th {
  font-size: 1.1rem;
  font-weight: bold;
}

#lockedDiv {
  margin-top: 5%;
}
</style>

<script>
import { api, externalApi, apiURL } from "@/axios";
import AdminAppLayout from "../../layout/AdminAppLayout.vue";
import { refreshSelectDropdown } from "@/m-css";
import defaultPic from '@/assets/picDefault.png';


export default {
  name: "EmployeesView",
  components: {
    AdminAppLayout,
  },
  data() {
    return {
      currentUser: {id: null},
      search: '',
      status: '',
      statusName: '',
      selectedOffice: '', 
      selectedPlantilla: '', 
      filtered: false,
      selectedPage: 1,
      employees: [],
      statusCounts: {},
      detailsLoader: false,
      listLoader: false,
      
      resetOption: '',
      generatedPassword: null,
      resetLoader: false,

      employeeModal: {
        user: {},
        plantilla: {},
        employment_status: {},
        service_status: {},
        salary_grade: {},
        eligibility: {},
        position: {},
        assigned_office: {},
        creator: {} 
      },
      typingTimer: null,
      editLoader: false,
      
      lockedEmployeeId: null,
      unlockReason: '',
      requestLoader: false,

      dropdowns: {
        positions: [],
        plantillas: [],
        eligibilities: [],
        employmentStatuses: [],
        serviceStatuses: [],
        offices: [],
        salarySteps: [],
      },

      caEdit: false,
      bpEdit: false,

      // PSGC Data
      regions: [],
      provinces: [],
      cities_or_municipalities: [],
      barangays: [],
      bp_provinces: [],
      bp_cities: [],
      bp_barangays: [],
      
      editForm: {
        id: null,
        first_name: '',
        middle_name: '',
        last_name: '',
        email: '',
        username: '',
        cellphone_number: '',
        birthday: '',
        sex: '',
        birthplace: '',
        address: '',
        employee_id_number: '',
        item_number: '',
        effectivity_date: '',
        base_salary: '',
        tin: '',
        sss: '',
        gsis: '',
        pagibig: '',
        philhealth: '',

        region: "",
        province: "",
        city_or_municipality: "",
        barangay: "",

        bp_region: "",
        bp_province: "",
        bp_city_or_municipality: "",
        bp_barangay: "",

        position_id: '',
        salary_grade_id: '',
        plantilla_id: '',
        eligibility_id: '',
        employment_status_id: '',
        service_status_id: '',
        assigned_office_id: '',

        salary_grade_display: "",
        salary_grade: "",
        salary_step: "",
        editSalaryAmount: "",
      },

      originalEditForm: null, 

      editErrors: {
        first_name: '',
        middle_name: '',
        last_name: '',
        email: '',
        username: '',
        cellphone_number: '',
        birthday: '',
        sex: '',
        employment_status_id: '',
        service_status_id: '',
        employee_id_number: '',
        plantilla_id: '',
        item_number: '',
        eligibility_id: '',
        position_id: '',
        assigned_office_id: '',
        effectivity_date: '',
        salary_step: '',
        base_salary: '',
        tin: '',
        sss: '',
        gsis: '',
        pagibig: '',
        philhealth: ''
      },

      errors: {
        caddress: '',
        baddress: '',
      },

      pagination: { current_page: 1, last_page: 1, total: 0 }

    };
  },
  computed: {
    visiblePages() {
      let pages = [];
      let start = Math.max(1, this.pagination.current_page - 2);
      let end = Math.min(this.pagination.last_page, start + 4);
      if (end - start < 4) {
          start = Math.max(1, end - 4);
      }
      for (let i = start; i <= end; i++) {
          pages.push(i);
      }
      return pages;
    },
    isEditFormChanged() {
      if (!this.originalEditForm) return false;
      for (let key in this.originalEditForm) {
        let origVal = String(this.originalEditForm[key] ?? '').trim();
        let newVal = String(this.editForm[key] ?? '').trim();
        if (origVal !== newVal) {
          return true;
        }
      }
      return false;
    }
  },
  methods: {
    openResetPasswordModal() {
      this.resetOption = '';
      this.generatedPassword = null;
      this.$nextTick(() => {
        const elem = document.getElementById('resetPasswordDiv');
        const instance = window.M.Modal.getInstance(elem) || window.M.Modal.init(elem, { dismissible: false });
        instance.open();
      });
    },
    // CHANGED: specifically finds the reset modal and closes it programmatically instead of globally
    closeResetModal() {
      this.resetOption = '';
      this.generatedPassword = null;
      const elem = document.getElementById('resetPasswordDiv');
      const instance = window.M.Modal.getInstance(elem);
      if (instance) {
        instance.close();
      }
    },
    async submitResetPassword() {
      if (!this.resetOption) return;

      this.resetLoader = true;
      try {
        const response = await api.post(`/employee/${this.employeeModal.id}/reset-password`, {
          delivery_method: this.resetOption
        });

        if (this.resetOption === 'screen') {
          this.generatedPassword = response.data.password; 
          if (typeof window.M !== 'undefined') {
            window.M.toast({html: 'Password generated successfully!', classes: 'green rounded'});
          }
        } else {
          if (typeof window.M !== 'undefined') {
            window.M.toast({html: 'New password sent to employee email!', classes: 'green rounded'});
          }
          // Also programmatic close here
          const elem = document.getElementById('resetPasswordDiv');
          const instance = window.M.Modal.getInstance(elem);
          if (instance) {
            instance.close();
          }
        }
      } catch (error) {
        console.error(error);
        if (typeof window.M !== 'undefined') {
          window.M.toast({html: 'Failed to reset password.', classes: 'red rounded'});
        }
      } finally {
        this.resetLoader = false;
      }
    },
    
    // get names for display chips
    getOfficeName(id) {
      const office = this.dropdowns.offices.find(o => o.id === id);
      return office ? office.name : '';
    },
    getPlantillaName(id) {
      const plantilla = this.dropdowns.plantillas.find(p => p.id === id);
      return plantilla ? plantilla.name : '';
    },
    
    // NEW: Function to remove a single filter type and trigger list reload
    removeSpecificFilter(filterType) {
      if (filterType === 'status') {
        this.status = '';
        this.statusName = '';
      } else if (filterType === 'search') {
        this.search = '';
      } else if (filterType === 'office') {
        this.selectedOffice = '';
      } else if (filterType === 'plantilla') {
        this.selectedPlantilla = '';
      }
      this.filterLists(1);
    },

    // filter resetting
    resetFilters() {
      this.filtered = false;
      this.status = '';
      this.statusName = '';
      this.search = '';
      this.selectedOffice = '';
      this.selectedPlantilla = '';
      this.filterLists(1);
    },
    //for employee list pagination
    changePage(page) {
      if (page < 1 || page > this.pagination.last_page || page === this.pagination.current_page) return;
      this.selectedPage = page;
      if (this.search || this.status || this.selectedOffice || this.selectedPlantilla) {
        this.filterLists(page);
      } else {
        this.getEmployees(page);
      }
    },
    //get employee list from backend
    async getEmployees(page = this.selectedPage) {
      this.listLoader = true;
      this.selectedPage = page;

      await api
      .get(`/employees?page=${page}`)
      .then((res) => {
        this.employees = res.data.employees.data;
        this.statusCounts = res.data.statusCounts;
        this.pagination = {
          current_page: res.data.employees.current_page,
          last_page: res.data.employees.last_page,
          total: res.data.employees.total
        };
        this.listLoader = false;
      })
      .catch((err) => {
        console.error(err.response);
      })
    },
    //to load the photo from the backend
    getPhoto(photo) {
      if (photo){
        const baseUrl = apiURL.replace(/\/api\/?$/, '');
        return `${baseUrl}/storage/${photo}`;
      } else {
        return defaultPic;
      }
    },
    //filter by search or by employment status
    async filterLists(page = 1) {

      this.employees = '';
      this.filtered = !!(this.status || this.search || this.selectedOffice || this.selectedPlantilla);
      this.listLoader = true;
      this.selectedPage = page;
      let statusID = this.status;
      
      await api.get(`/employees?page=${page}&searchQuery=${this.search}&statusQuery=${statusID}&officeQuery=${this.selectedOffice}&plantillaQuery=${this.selectedPlantilla}`)
      .then((res) => {
        this.employees = res.data.employees.data;
        this.pagination = {
          current_page: res.data.employees.current_page,
          last_page: res.data.employees.last_page,
          total: res.data.employees.total
        };
      })
      .catch((err) => {
        console.error(err);
      })
      .finally(() => {
        setTimeout(() => {
          this.listLoader = false;
        }, 1000);
      })
    },
    //for delay kapag naga search
    handleSearchInputDelay() {
        clearTimeout(this.typingTimer);

        this.typingTimer = setTimeout(() => {
            this.filterLists();
        }, 500);
    },
    //filter toggle for employment status
    toggleStatus(id, name) {
      if (this.status === id) {
        this.status = '';
        this.statusName = '';
      } 
      else {
        this.status = id;
        this.statusName = name;
      }
      
      this.filterLists();
    },
    //for the add employee button
    goToAddEmployee() {
      this.$router.push('/add-employee');
    },
    //get details for viewing
    async getEmployeeDetails(id) {
      this.detailsLoader = true;
        await api.get(`/employee/${id}`)
        .then((res) => {
          this.employeeModal = res.data;
          console.log(this.employeeModal.effectivity_date);
          this.detailsLoader = false;
        })
        .catch((err) => {
          console.error(err.response);
        })
    },
    //fetch the datas for select inputs...
    async getListForDropdowns() {
        await api.get('/dropdowns-lists')
        .then((res) => {
            this.dropdowns.positions = res.data.positions;
            this.dropdowns.plantillas = res.data.plantillas;
            this.dropdowns.eligibilities = res.data.eligibilities;
            this.dropdowns.employmentStatuses = res.data.employmentStatuses;
            this.dropdowns.serviceStatuses = res.data.serviceStatuses;
            this.dropdowns.offices = res.data.offices;
            
            refreshSelectDropdown(this);
        })
        .catch(() => {
            console.log("An error occured...");
        })
    },

    
    //for edit modal
    openEditModal(employee) {

      // 1. Check if the employee record is locked
      if (employee.is_locked === 1 || employee.is_locked === true) {
        this.lockedEmployeeId = employee.id;
        this.unlockReason = ''; // Clear previous input
        
        this.$nextTick(() => {
          const elem = document.getElementById('lockedDiv');
          const instance = window.M.Modal.getInstance(elem) || window.M.Modal.init(elem);
          instance.open();
          if (typeof window.M !== 'undefined') window.M.updateTextFields();
        });
        return; // Stop execution, don't load the edit form
      }

      // 2. If not locked, proceed with opening the standard edit modal programmatically
      this.detailsLoader = true;
      
      // CLEAR ANY LEFTOVER ERRORS
      for (let key in this.editErrors) {
          this.editErrors[key] = '';
      }

      this.loadEditSalaryAmount();
      this.getListForDropdowns();
      this.getRegions();
      
      // Open the edit modal
      this.$nextTick(() => {
        const editElem = document.getElementById('editDiv');
        const editInstance = window.M.Modal.getInstance(editElem) || window.M.Modal.init(editElem);
        editInstance.open();
      });

      api.get(`/employee/${employee.id}`)
        .then((response) => {
          const data = response.data;

          // Helper to format timestamps into YYYY-MM-DD for HTML date inputs
          const formatForInput = (dateString) => {
            if (!dateString) return '';
            return dateString.split('T')[0]; 
          };

          this.editForm = {
            id: data.id,
            first_name: data.first_name || '',
            middle_name: data.middle_name || '',
            last_name: data.last_name || '',
            email: data.user ? data.user.email : '',
            username: data.user ? data.user.username : '',
            cellphone_number: data.cellphone_number || '',
            birthday: formatForInput(data.birthday),
            sex: data.sex || '',
            birthplace: data.birthplace || '',
            address: data.address || '',
            employee_id_number: data.employee_id_number || '',
            item_number: data.item_number || '',
            effectivity_date: formatForInput(data.effectivity_date),
            base_salary: data.base_salary || '', // For JOs
            tin: data.tin || '',
            gsis: data.gsis || '',
            sss: data.sss || '',
            pagibig: data.pagibig || '',
            philhealth: data.philhealth || '',

            position_id: data.position_id || '',
            plantilla_id: data.plantilla_id || '',
            eligibility_id: data.eligibility_id || '',
            employment_status_id: data.employment_status_id || '',
            service_status_id: data.service_status_id || '',
            assigned_office_id: data.assigned_office_id || '',
            salary_grade_id: data.salary_grade_id,
            
            salary_grade: data.position ? data.position.salary_grade_level : '',
            salary_grade_display: data.position ? data.position.salary_grade_level : '',
            salary_step: data.salary_grade ? data.salary_grade.step : '',
          };

          if (this.editForm.employee_id_number) {
              this.editForm.employee_id_number = this.editForm.employee_id_number
                  .replace('LTO-COS-', '')
                  .replace('LTO-RO2-', '');
          }
          if (this.editForm.item_number) {
              this.editForm.item_number = this.editForm.item_number
                  .replace('OSEC-DOTrB-', '')
          }


          if (this.editForm.salary_grade) {
             this.getSgSteps(this.editForm.salary_grade);
          }

          this.$nextTick(() => {
            if (typeof window.M !== 'undefined') window.M.updateTextFields();
            this.originalEditForm = { ...this.editForm }; // Save state after all initializations
            this.detailsLoader = false;
          });

        })
        .catch((error) => {
          console.error(error);
          if (typeof window.M !== 'undefined') {
             window.M.toast({html: 'Failed to load employee data.', classes: 'red'});
          }
          this.detailsLoader = false;
        });
    },
    // get steps for specific grade...
    async getSgSteps(salaryGrade) {
        await api
        .get("/get-salary-steps/" + salaryGrade)
        .then((res) => {
            this.dropdowns.salarySteps = res.data.steps;
        })
        .catch(() => {
            console.log("error occured while trying to get the steps...")
        })
            
        this.$nextTick(() => {
            window.M.FormSelect.init(document.getElementById('edit_salary_step'));
        });
    },
    //for fetching the sg steps when position changes in edit modal
    handleEditPositionChange() {
      this.$nextTick(() => {
        let selectedPosition = this.dropdowns.positions.find(pos => pos.id === this.editForm.position_id);
        
        if (selectedPosition) {
            this.editForm.salary_grade = selectedPosition.salary_grade_level;
            this.editForm.salary_grade_display = selectedPosition.salary_grade_level;
            
            this.editForm.salary_step = "";
            this.editForm.editSalaryAmount = ""; 
            this.editForm.salary_grade_id = ""; 
            
            this.getSgSteps(this.editForm.salary_grade);
        }
      });
    },
    // for salary amount base sa sg at step
    loadEditSalaryAmount() {
      let salarySteps = this.dropdowns.salarySteps;
      if (!salarySteps || salarySteps.length === 0) return;

      for(let i = 0; i < salarySteps.length; i++) {
          if(salarySteps[i].grade == this.editForm.salary_grade && salarySteps[i].step == this.editForm.salary_step) {
              this.editForm.editSalaryAmount = salarySteps[i].salary_amount;
              this.editForm.salary_grade_id = salarySteps[i].id; 
              break;
          }
      }
    },
    // UPDATED submitEditForm WITH AUTO FOCUS AND ERROR HIGHLIGHTING
    submitEditForm() {
      this.editLoader = true;
      
      // Clear previous errors
      for (let key in this.editErrors) {
          this.editErrors[key] = '';
      }
      
      let payload = { ...this.editForm };
      
      if (payload.employment_status_id == 3) {
          payload.salary_grade_id = null;
          payload.item_number = null;
      }
      
      for (let key in payload) {
          if (payload[key] === "") {
              payload[key] = null;
          }
      }

      api.put(`/employee/${this.editForm.id}`, payload)
        .then((response) => {
          if (response.status === 200 || response.status === 204) {
            const elem = document.getElementById('editDiv');
            const instance = window.M.Modal.getInstance(elem);
            if (instance) instance.close();
            
            this.getEmployees(this.selectedPage);
            
            if (typeof window.M !== 'undefined') {
              window.M.toast({html: 'Employee updated successfully!', classes: 'green'});
            }
          }
        })
        .catch((error) => {
          if (error.response && error.response.status === 422) {
              const errors = error.response.data.errors;
              
              // 1. Check if the 'errors' object actually exists (for Laravel validation rules)
              if (errors) {
                  // Map the errors to the editErrors object so the HTML updates
                  for (let field in errors) {
                      this.editErrors[field] = errors[field][0];
                  }

                  // AUTO FOCUS LOGIC
                  this.$nextTick(() => {
                      const errorFields = Object.keys(errors);
                      if (errorFields.length > 0) {
                          const firstFieldKey = errorFields[0];
                          let targetElement = this.$refs[firstFieldKey];

                          if (Array.isArray(targetElement)) targetElement = targetElement[0];

                          if (targetElement) {
                              if (targetElement.tagName && targetElement.tagName.toLowerCase() === 'select' && !targetElement.classList.contains('browser-default')) {
                                  const wrapper = targetElement.closest('.select-wrapper');
                                  if (wrapper) {
                                      const materializeInput = wrapper.querySelector('input.select-dropdown');
                                      if (materializeInput) {
                                          materializeInput.focus();
                                          materializeInput.scrollIntoView({ behavior: 'smooth', block: 'center' });
                                      }
                                  }
                              } else {
                                  targetElement.focus();
                                  targetElement.scrollIntoView({ behavior: 'smooth', block: 'center' });
                              }
                          }
                      }
                  });

                  if (typeof window.M !== 'undefined') {
                      window.M.toast({html: 'Please fix the highlighted errors.', classes: 'red rounded', displayLength: 4000});
                  }
              } 
              // 2. If it's a 422 but has no 'errors' object, show the raw message (e.g. "Pending edit already exists")
              else if (error.response.data.message) {
                  if (typeof window.M !== 'undefined') {
                      window.M.toast({html: error.response.data.message, classes: 'orange darken-2 rounded', displayLength: 4000});
                  }
              }
          } else {
              if (typeof window.M !== 'undefined') {
                  window.M.toast({html: 'Something went wrong. Check console.', classes: 'red rounded'});
              }
              console.error("Failed to update employee:", error);
          }
        })
        .finally(() => {
          this.editLoader = false;
        });
    },
    // New function to handle the actual submission of the unlock request
    async submitUnlockRequest() {
      this.requestLoader = true;

      // 1. Clean the reason string (kills horizontal gaps, keeps newlines, trims edges)
      const rawReason = this.unlockReason || '';
      const reason = rawReason.replace(/[^\S\r\n]+/g, ' ').trim();

      try {
        // 2. Make the API call
        await api.post(`/employee/${this.lockedEmployeeId}/request-unlock`, { reason });

        // 3. Handle Success
        if (typeof window.M !== 'undefined') {
          window.M.toast({ html: 'Unlock request sent successfully!', classes: 'green' });
          
          const modalElement = document.getElementById('lockedDiv');
          if (modalElement) {
            const instance = window.M.Modal.getInstance(modalElement);
            instance?.close(); 
          }
        }
      } catch (error) {
        // 4. Handle Error
        console.error("Unlock request failed:", error);
        
        if (typeof window.M !== 'undefined') {
          const errorMessage = error.response?.data?.message || 'Failed to send request.';
          window.M.toast({ html: errorMessage, classes: 'red' });
        }
      } finally {
        // 5. Cleanup
        this.requestLoader = false;
      }
    },
    //for changing address
    resetAddress(type) {
      if (type === 'bp') {
        this.bpEdit = this.bpEdit ? false : true;
        this.editForm.bp_region = '';
        this.editForm.bp_province = '';
        this.editForm.bp_city_or_municipality = '';
        this.editForm.bp_barangay = '';
        this.bp_provinces = [];
        this.bp_cities = [];
        this.bp_barangays = [];
      } else {
        this.caEdit = this.caEdit ? false : true;
        this.editForm.region = '';
        this.editForm.province = '';
        this.editForm.city_or_municipality = '';
        this.editForm.barangay = '';
        this.provinces = [];
        this.cities_or_municipalities = [];
        this.barangays = [];
      }

      this.$nextTick(() => {
        if (typeof window.M !== 'undefined') window.M.updateTextFields();
      });
    },
    //for saving new address
    saveAddress(type) {
      if (type === 'bp') {
        if (!this.editForm.bp_region || !this.editForm.bp_province || !this.editForm.bp_city_or_municipality || !this.editForm.bp_barangay) {
          this.showError('Please complete all birthplace fields.', 'baddress');
          return;
        }else {
          if (typeof window.M !== 'undefined') {
            window.M.toast({html: 'Birthplace updated successfully!', classes: 'green'});
          }
        }
        this.editForm.birthplace = [this.editForm.bp_barangay, this.editForm.bp_city_or_municipality, this.editForm.bp_province, this.editForm.bp_region].filter(Boolean).join(', ');
        this.bpEdit = false;
      } else {
        if (!this.editForm.region || !this.editForm.province || !this.editForm.city_or_municipality || !this.editForm.barangay) {
          this.showError('Please complete all address fields.', 'caddress');
          return;
        } else {
          if (typeof window.M !== 'undefined') {
            window.M.toast({html: 'Address updated successfully!', classes: 'green'});
          }
        }
        this.editForm.address = [this.editForm.barangay, this.editForm.city_or_municipality, this.editForm.province, this.editForm.region].filter(Boolean).join(', ');
        this.caEdit = false;
      }
    },
    // NEW: Function to Undo changes back to the originally loaded string
    undoAddress(type) {
      if (type === 'bp') {
        this.editForm.birthplace = this.originalEditForm.birthplace;
        if (typeof window.M !== 'undefined') {
          window.M.toast({html: 'Birthplace changes undone.', classes: 'orange'});
        }
      } else {
        this.editForm.address = this.originalEditForm.address;
        if (typeof window.M !== 'undefined') {
          window.M.toast({html: 'Address changes undone.', classes: 'orange'});
        }
      }
    },
    // to format the mobile numbers and government ID inputs
    formatNumber(value, pattern) {
      if (!value) return "";
      let numbers = value.replace(/\D/g, "");
      let result = "";
      let numIndex = 0;
      for (let i = 0; i < pattern.length; i++) {
        if (pattern[i] === "0") {
          if (numbers[numIndex]) {
            result += numbers[numIndex];
            numIndex++;
          }
        } else {
          if (numbers[numIndex]) {
            result += pattern[i];
          }
        }
      }
      return result;
    },
    // to automatically capitalize certain fields
    capitalize(field) {
      let value = this.editForm[field];
      if (!value) return;
      this.editForm[field] = value.toUpperCase();
    },

    async getRegions() {
        await externalApi.get("https://psgc.gitlab.io/api/regions/")
        .then((res) => {
            this.regions = res.data;
            console.log(this.regions);
        })
        .catch((err) => { console.log(err); });
    },

    async handleRegionChange(type) {
        let rName = type === 'bp' ? this.editForm.bp_region : this.editForm.region;
        let region = this.regions.find(r => r.name === rName);
        
        if (type === 'bp') {
            this.bp_provinces = []; this.bp_cities = []; this.bp_barangays = [];
            this.editForm.bp_province = ''; this.editForm.bp_city_or_municipality = ''; this.editForm.bp_barangay = '';
        } else {
            this.provinces = []; this.cities_or_municipalities = []; this.barangays = [];
            this.editForm.province = ''; this.editForm.city_or_municipality = ''; this.editForm.barangay = '';
        }
        if(!region) return;

        await externalApi.get(`https://psgc.gitlab.io/api/regions/${region.code}/provinces/`)
        .then(async (res) => {
            let data = res.data;
            if (data.length === 0) { // NCR Edge Case
                const cityRes = await externalApi.get(`https://psgc.gitlab.io/api/regions/${region.code}/cities-municipalities/`);
                data = [{ code: region.code, name: 'NCR' }];
                if (type === 'bp') {
                    this.editForm.bp_province = 'NCR';
                    this.bp_cities = cityRes.data;
                } else {
                    this.editForm.province = 'NCR';
                    this.cities_or_municipalities = cityRes.data;
                }
            }
            if (type === 'bp') this.bp_provinces = data;
            else this.provinces = data;
        }).catch(err => console.log(err));
    },

    async handleProvinceChange(type) {
        let pName = type === 'bp' ? this.editForm.bp_province : this.editForm.province;
        let provList = type === 'bp' ? this.bp_provinces : this.provinces;
        let prov = provList.find(p => p.name === pName);

        if (type === 'bp') {
            this.bp_cities = []; this.bp_barangays = [];
            this.editForm.bp_city_or_municipality = ''; this.editForm.bp_barangay = '';
        } else {
            this.cities_or_municipalities = []; this.barangays = [];
            this.editForm.city_or_municipality = ''; this.editForm.barangay = '';
        }
        if(!prov) return;

        let endpoint = prov.name === 'NCR' 
            ? `https://psgc.gitlab.io/api/regions/${prov.code}/cities-municipalities/`
            : `https://psgc.gitlab.io/api/provinces/${prov.code}/cities-municipalities/`;
            
        await externalApi.get(endpoint)
        .then((res) => {
            if (type === 'bp') this.bp_cities = res.data;
            else this.cities_or_municipalities = res.data;
        }).catch(err => console.log(err));
    },

    async handleCityChange(type) {
        let cName = type === 'bp' ? this.editForm.bp_city_or_municipality : this.editForm.city_or_municipality;
        let cityList = type === 'bp' ? this.bp_cities : this.cities_or_municipalities;
        let city = cityList.find(c => c.name === cName);

        if (type === 'bp') {
            this.bp_barangays = []; this.editForm.bp_barangay = '';
        } else {
            this.barangays = []; this.editForm.barangay = '';
        }
        if(!city) return;

        await externalApi.get(`https://psgc.gitlab.io/api/cities-municipalities/${city.code}/barangays/`)
        .then((res) => {
            if (type === 'bp') this.bp_barangays = res.data;
            else this.barangays = res.data;
        }).catch(err => console.log(err));
    },

    //format dates sa mas maganda
    formatDate(date) {
      if (!date) return '';

      return new Date(date).toLocaleDateString('en-PH', {
        year: 'numeric',
        month: 'long',
        day: 'numeric'
      });
    },
    //format currency with commas and 2 decimal places
    formatCurrency(amount) {
      if (amount === null || amount === undefined || amount === '') {
        return '0.00';
      }

      return Number(amount).toLocaleString('en-PH', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      });
    },
    //for showing error messages
    showError(msg, errVar) {
      this.errors[errVar] = msg;
      setTimeout(() => {
        this.errors[errVar] = "";
      }, 3000);
    },
  },
  mounted() {
    
    this.getListForDropdowns();
    this.getEmployees();

    api.get('/user')
    .then(response => {
      this.currentUser = response.data;
    }).catch(error => {
      console.error('Error fetching current user:', error);
    });
  },
  watch: {
    'editForm.salary_step': function() {
        this.loadEditSalaryAmount();
    },

    'dropdowns.salarySteps': function() {
        this.loadEditSalaryAmount();
    },
  },
};
</script>